import React, { useState } from 'react';
import { WelcomeOfferStyled } from './WelcomeOffersStyled';
import { PromotionalOfferStyled } from './PromotionalOffersStyled';
import { getImageUrlWithSize } from '@common/Utility/common-utils';

const PromotionalOffer = ({ cmsResult }) => {
    const {
        iconImage,
        backgroundImageApp,
        fullImageBanner,
        title,
        name,
        description,
        subTitle,
    } = cmsResult;

    const modifieddescription = description?.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');

    return (
        <PromotionalOfferStyled
            style={{
                background: `url(${backgroundImageApp || fullImageBanner}) no-repeat`,
                backgroundSize: '100% 100%',
                border: '1px solid #2B3894',
                borderRadius: '10px',
                marginRight: '8px',
                width: '355px',
                height: '90px'
            }}
        >
            <div className="left-content">
                <img
                    src={getImageUrlWithSize(iconImage, 50, 50)}
                    alt="image"
                    className="image-style"
                />
                <div className="title-subtitle-container">
                    <div className="title-above-subtitle">{name || title}</div>
                    <div
                        className="subtitle"
                        dangerouslySetInnerHTML={{ __html: modifieddescription || subTitle}}
                    ></div>
                </div>
            </div>
        </PromotionalOfferStyled>
    );
};

export default PromotionalOffer;
